import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Badge } from '@/components/ui/daisy';
import Resource from '@/models/Resource';

type ResourceBadgesProps = {
  resource: Pick<Resource, 'isMandatory' | 'onlyTeacher'>;
};

export default function ResourceBadges({ resource }: ResourceBadgesProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.resourcesTab',
  });

  return (
    <div className="flex flex-wrap items-center gap-2">
      <ConditionalRenderer condition={resource.isMandatory}>
        <Badge color="primary" size="md">
          {t('mandatoryBadge')}
        </Badge>
      </ConditionalRenderer>
      <ConditionalRenderer condition={resource.onlyTeacher}>
        <Badge color="info" size="md">
          {t('onlyTeacherBadge')}
        </Badge>
      </ConditionalRenderer>
    </div>
  );
}
